<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import upprocess from "../../../../common/upProcess/index.vue";
import uploadFile from "../../../../common/uploadFile/index.vue";
import updateywkm from "../../../../common/updateywkm/index.vue";
import { subLegerUpload, subLegerUploadStep } from "../../../../../api/subLeger.js";
import config from "../../../../../../configHttp.js";
export default {
  components: {
    upprocess,
    uploadFile,
    updateywkm,
  },
  data: function () {
    return {
      uptype: 1,
      importType: "0",
      mboptions: getdata().mboptions,

      count: 5,
      // successCount:0,
      successdata: { successCount: 0, errorCount: 0 },
      batchNum: "",
      // timer:null,
      upformdata: {}, //文件信息
    };
  },
  methods: {
    forbackup() {
      this.$refs["uploadfileRef"].forrefresh();
      this.uptype = 1;

      clearInterval(this.timer);
    },
    forchooseindex(index) {
      this.$emit("forchooseindex", index);
    },
    toCustomTemplate() {
      this.$router.push("/CustomTemplate");
    },
    getuploadparams(e) {
      this.upformdata = e;
      // 获取到的文件信息
    },
    fordownloadmb() {
      let params = {
        downUrl: config.baseURL + "subLeger/iinv/dowloadTemplate",
        typeObj: {
          toForm: false,
          fileName: "进项明细账导入模板",
          fileType: "xlsx",
          failUrl:this.$winURl
        },
      };
      this.$downloadcommon(params);
      ///
    },
    async importSubLegerExcel() {
      this.count = 5;
      if (this.$emptyandnull(this.upformdata.upfile)) {
        this.$message.error("请选择要上传的文件");
        return false;
      }

      let formData = {
        importType: this.importType,
        file: this.upformdata.upfile,
        iinvFlag: true
      };
      subLegerUpload(formData).then(async (res) => {
        if (res.data.code == 1) {
          if(res.data.data) {
              if (res.data.data.checkResp && res.data.data.checkResp.exists) {
                  let checkResp = res.data.data.checkResp;
                  let checkDetails = checkResp.details;
                  // TODO 提示信息
                  let processData = {iinvFlag: true, batchNo: res.data.data.batchNo, unMatchProcess: '0', matchedProcess: '0', holdProcess: '0'};
                  
                  let unMatchs = checkDetails.find(obj=>obj.code=='0');
                  let matcheds = checkDetails.find(obj=>obj.code=='1');
                  let holdMatchs = checkDetails.find(obj=>obj.code=='2');
                  if (unMatchs) {
                    processData.unMatchProcess = await this.confirmDialog(unMatchs.voucherNos, '已存在，请确认是否仍需导入，确认后将覆盖已存在的数据！');
                  }
                  if (matcheds) {
                    processData.matchedProcess = await this.confirmDialog(matcheds.voucherNos, '已存在且状态为已匹配，请确认是否仍需导入，确认后将撤销相关已匹配的数据！');
                  }
                  if (holdMatchs) {
                    processData.holdProcess = await this.confirmDialog(holdMatchs.voucherNos, '已存在且状态为暂不处理，请确认是否仍需导入，确认后将覆盖已存在的数据！');
                  }
                  await subLegerUploadStep(processData).then((res) => {
                    if (res.data.code == 1) {
                      if(res.data.data) {
                        this.refreshUploadAfter(res);
                      } else {
                        this.$message.error('系统错误');
                      }
                    } else {
                      this.$message.error(res.data.msg);
                    }
                  });
              } else {
                this.refreshUploadAfter(res);
              }
          } else {
            this.$message.error('系统错误');
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    async confirmDialog(voucherNos, msg) {
      return this.$showConfirm({
          message: '凭证'+voucherNos.join('、')+msg
        }).then(res => {
          if (res == 'confirm') {
            return '1';
          } else {
            return '0';
          }
        });
    },
    refreshUploadAfter(res) {
      //如果成功数量为0则跳转至结果页面
      if (res.data.data && res.data.data.successCount == 0 || !res.data.data.successCount) {
        this.$message.error(
          "当前导入文件成功条数为0，具体错误信息可到上传结果界面查看"
        );
      } else {
        this.uptype = 2;
        this.batchNum = res.data.data.batchNo;
        this.successdata = {
          successCount: res.data.data.successCount,
          errorCount: res.data.data.errorCount,
        };
        this.timer = setInterval(() => {
          this.count--;
          if (self._isDestroyed) {
            clearInterval(this.timer);
            return false;
          }
          if (this.count == 0) {
            this.$refs["uploadfileRef"].forrefresh();
            this.uptype = 1;
            clearInterval(this.timer);
          }
        }, 1000);
      }
    }
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
